module.exports = __webpack_public_path__ + "img/logo-WC-microsite.569c7b5a.svg";